import { useCallback, useState } from 'react';

export type LoadingStates = {
  isLoading: boolean;
  isLoadingIds: string[];
  updateIsLoading: (isLoading: boolean) => void;
  updateIsLoadingIds: (id: string, isAdding?: boolean) => void;
  getIsLoading: (id: string) => boolean;
};

export default function useLoadingState(
  initialIsLoading = false,
  initialIsLoadingIds = [] as string[],
): LoadingStates {
  const [isLoading, setIsLoading] = useState(initialIsLoading);
  const [isLoadingIds, setIsLoadingIds] =
    useState<string[]>(initialIsLoadingIds);

  const updateIsLoading = useCallback(
    (isLoading: boolean) => setIsLoading(isLoading),
    [],
  );

  const updateIsLoadingIds = useCallback(
    (id: string, isAdding = true) =>
      setIsLoadingIds((prev) =>
        isAdding
          ? Array.from(new Set([...prev, id]))
          : prev.filter((i) => i !== id),
      ),
    [],
  );

  const getIsLoading = useCallback(
    (id: string) => isLoading || isLoadingIds.includes(id),
    [isLoading, isLoadingIds],
  );

  return {
    isLoading,
    isLoadingIds,
    updateIsLoading,
    updateIsLoadingIds,
    getIsLoading,
  };
}
